import React from "react";
import { NavLink } from "react-router-dom";

import {
  Wallet,
  ShieldCheck,
  Landmark,
  PiggyBank,
  Ticket,
  Smartphone,
  Activity,
  Radio,
} from "lucide-react";

import "../Styles/Header.css";

const Header = () => {

  const currentDate =
    new Date().toLocaleDateString(
      "en-US",
      {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      }
    );

  const links = [
    {
      to: "/accounts",
      label: "Accounts",
      icon: <Wallet size={16} />,
    },

    {
      to: "/cheque-tracker",
      label: "Cheque Tracker",
      icon: <ShieldCheck size={16} />,
    },

    {
      to: "/mmg",
      label: "MMG",
      icon: <Landmark size={16} />,
    },

    {
      to: "/loan",
      label: "Loan",
      icon: <PiggyBank size={16} />,
    },

    {
      to: "/lottery",
      label: "Guyana Lottery",
      icon: <Ticket size={16} />,
    },

    {
      to: "/phone-cards",
      label: "Phone Cards",
      icon: <Smartphone size={16} />,
    },

    {
  to: "/sim-cards",
  label: "SIM Cards",
  icon: <Radio size={16} />,
},
  ];

  return (
    <header className="modern-header">

      {/* =========================================
          LEFT
      ========================================= */}

      <div className="header-left">

        <div className="header-live-dot"></div>

        <div className="header-date-group">
          <h4>{currentDate}</h4>
          <p>System operational</p>
        </div>

      </div>

      {/* =========================================
          CENTER NAV
      ========================================= */}

      <nav className="header-nav">

        {links.map((link) => (

          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) =>
              isActive
                ? "header-link active"
                : "header-link"
            }
          >

            {link.icon}

            <span>{link.label}</span>

          </NavLink>

        ))}

      </nav>

      {/* =========================================
          RIGHT
      ========================================= */}

      <div
        className="header-console"
        onClick={() =>
          (window.location.href = "/")
        }
      >

        <Activity size={18} />

        <span>RCS ADMIN CONSOLE</span>

      </div>

    </header>
  );
};

export default Header;